export const REDUCED_MOTION_MEDIA_QUERY = "(prefers-reduced-motion: reduce)";

export const getSmoothScrollBehavior = (): ScrollBehavior => (window.matchMedia?.(REDUCED_MOTION_MEDIA_QUERY).matches ? "auto" : "smooth");
